import {ReactComponent as Icon} from '@image/icon_set.svg';

const IconSet = () => {
    return   <Icon />;
};

export default IconSet;